import { useState } from "react";
import { AboutUs } from "./AboutUs/AboutUs";
import ContactUs from "./ContactUs/ContactUs";
import { GallerySection } from "./Gallery/LandingPageGallery";

import ServiceInquiryModal from "./Modal/ServiceInquiryModal";
import Navbar from "./NavBar/Nav";
import OurProcess from "./OurProcess/OurProcess";
import { PartnerSection } from "./Partners/Partners";
import ServiceCard from "./Services/ServiceCard";
import Footer from "./Footer/Footer";
import { services } from "./constant";

const SHOW_GALLERY = false;

const OuterWrapper = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState("");

  return (
    <>
      <div
        className="vista-page-shell"
        style={{
          position: "relative",
          background:
            "radial-gradient(circle at 2% 4%, rgba(244,125,113,0.13), rgba(244,125,113,0) 40%), radial-gradient(circle at 92% 98%, rgba(128,51,65,0.1), rgba(128,51,65,0) 42%), #fcfaf7",
          overflow: "hidden",
        }}
      >
        <Navbar isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
        <ServiceCard
          services={services}
          setIsModalOpen={setIsModalOpen}
          setSelectedService={setSelectedService}
        />
        <AboutUs setIsModalOpen={setIsModalOpen} />
        <OurProcess />
        <PartnerSection />
        {SHOW_GALLERY && <GallerySection />}
        <ContactUs />
        <Footer />
      </div>

      <ServiceInquiryModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        selectedService={selectedService}
      />
    </>
  );
};

export default OuterWrapper;
